/* eslint-disable react/no-danger */
import React from 'react';
import { useT } from 'talkr';
import questions from '../../survey/questions';
import s from './index.module.scss';

import icon from './img/icon.svg';

const OUT_POSITION_CLASS_NAME = {
	left: s.outPositionLeft,
	right: s.outPositionRight
};

function WeightRecommendations () {
	const { T } = useT();
	const weight = questions.getAnswers({ questionName: 'weight' });
	const height = questions.getAnswers({ questionName: 'height' });
	const userWeightValue = weight.units.value === 'kg' ? weight.value.value : weight.value.value * 0.453592;
	const userHeightValue = height.units.value === 'cm' ? height.value.value : height.value.value * 2.54;
	const bmiProgress = (userWeightValue / (((userHeightValue / 100) * (userHeightValue / 100)))).toFixed(2);
	let outPosition;

	const idealBMIValue = 21;

	const idealWeight = (((userHeightValue / 100) * (userHeightValue / 100)) * idealBMIValue).toFixed(0);

	if (bmiProgress <= 18.5) {
		outPosition = 'left';
	}
	if (bmiProgress >= 25) {
		outPosition = 'right';
	}

	let currentWeightToRender = `${(+userWeightValue).toFixed(0)} ${T(`value_${weight.units.value}`)}`;
	let goalWeightToRender = `${(+idealWeight).toFixed(0)} ${T(`value_${weight.units.value}`)}`;
	let weightToChange = 0;

	if (outPosition === 'left') {
		weightToChange = (idealWeight - (+userWeightValue)).toFixed(0);
	}

	if (outPosition === 'right') {
		weightToChange = (+userWeightValue) - idealWeight;
	}

	if (weight.units.value !== 'kg' && weightToChange) {
		currentWeightToRender = `${(+userWeightValue * 2.20462).toFixed(0)} ${T('value_lbs')}`;
		goalWeightToRender = `${(+idealWeight * 2.20462).toFixed(0)} ${T('value_lbs')}`;
		weightToChange = `${Math.abs(((+idealWeight * 2.20462).toFixed(0) - (+userWeightValue * 2.20462).toFixed(0)))} ${T('value_lbs')}`;
	} else if (weightToChange) {
		weightToChange = `${(+weightToChange).toFixed(0)} ${T('value_kg')}`;
	}

	function getTitle () {
		if (outPosition === 'left') {
			return window.locales.weight_recommendations_title_gain.replace('<span id="weightToChange">__weight__</span>', `<span class="${s.weightToChange}">${weightToChange}</span>`);
		}
		if (outPosition === 'right') {
			return window.locales.weight_recommendations_title.replace('<span id="weightToChange">__weight__</span>', `<span class="${s.weightToChange}">${weightToChange}</span>`);
		}
	}

	return (
		<div className={`${s.weightRecommendations} ${OUT_POSITION_CLASS_NAME[outPosition]}`}>
			<div className={s.titleWrapper}>
				<h2 className={s.title} dangerouslySetInnerHTML={{ __html: getTitle() }} />
				<img className={s.titleIcon} src={icon} alt="" />
			</div>
			<div className={s.chartWrapper}>
				<div className={s.chart}>
					<div className={s.chartLeft}>
						{outPosition === 'left' && (
							<div className={`${s.point} ${s.pointCurrentLeft}`}>
								<div className={s.pointName}>{T('weight_recommendations_current')}</div>
								<div className={s.pointValue}>{currentWeightToRender}</div>
							</div>
						)}
					</div>
					<div className={s.chartMiddle}>
						<div className={s.point}>
							<div className={s.pointName}>{T('weight_recommendations_goal')}</div>
							<div className={s.pointValue}>{goalWeightToRender}</div>
						</div>
						{T('weight_recommendations_normal_range')}
					</div>
					<div className={s.chartRight}>
						{outPosition === 'right' && (
							<div className={`${s.point} ${s.pointCurrentRight}`}>
								<div className={s.pointName}>{T('weight_recommendations_current')}</div>
								<div className={s.pointValue}>{currentWeightToRender}</div>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}

export default WeightRecommendations;
